import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const ContentProgressApi = createApi({
  reducerPath: "ContentProgressApi",
  baseQuery: customBaseQuery,
  tagTypes: ["ContentProgress"],
  endpoints: (builder) => ({
    contentProgressUpdateApi: builder.query({
      query: (req: any) => {
        return {
          url: `/progress/update/${req.contentId}?type=${req.type}`,
          method: "GET"
        };
      },
      extraOptions: { service: "Progress" }
    }),

    getContentProgressApi: builder.query({
      query: (contentId: any) => {
        return {
          url: `/progress/progress/${contentId}`,
          method: "GET"
        };
      },
      extraOptions: { service: "Progress" }
    })
  })
});

export const {
  useLazyContentProgressUpdateApiQuery,
  useLazyGetContentProgressApiQuery,
  useGetContentProgressApiQuery,
  useContentProgressUpdateApiQuery
} = ContentProgressApi;
